module.exports = __webpack_public_path__ + "static/media/Leccion-4-9-Ahorra-te-toca-a-Ti.beff1743.pdf";